import { memo, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectBasketId, selectTradeOrderCount, selectTradeOrderSecurityKeysSignature, selectTradeOrders } from '../../selectors/strategyBuilder'
import { selectPositions } from '../../selectors/positions'
import { getSortedTradedExpiries } from '../../util/strategyBuilder'
import { updateNearestExpiry } from '../../reducer/strategyBuilder.reducer'
import store from '../../store'

/** Keeps nearest-expiry in sync without re-rendering the strategy builder content tree on every trade order edit. */
const StrategyBuilderNearestExpiryEffects = () => {
    const dispatch = useDispatch()
    const basketId = useSelector(selectBasketId)
    const tradeOrderCount = useSelector(selectTradeOrderCount)
    const tradeOrderSecurityKeysSignature = useSelector(selectTradeOrderSecurityKeysSignature)
    const positions = useSelector(selectPositions)
    const basketPositions = useMemo(() => positions?.filter((p) => p.basketId === basketId) ?? [], [positions, basketId])

    useEffect(() => {
        const tradeOrders = selectTradeOrders(store.getState())
        getSortedTradedExpiries(tradeOrders || [], basketPositions || []).then((expiries) => {
            dispatch(updateNearestExpiry((expiries || [])[0] || 0))
        })
    }, [tradeOrderCount, tradeOrderSecurityKeysSignature, basketPositions, dispatch])

    return null
}

export default memo(StrategyBuilderNearestExpiryEffects)
